export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_TIME_FORMAT = 'HH:ss';
export const LOCAL_TIME_FORMAT = 'LT';
